(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('TeamCodeController', TeamCodeController);


    TeamCodeController.$inject = ['$translate', '$timeout', 'ProfileService'];

    function TeamCodeController ($translate, $timeout, ProfileService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        // vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {email:null,code:null};
        vm.success = false;
        vm.loading = false;
        vm.errorExist = false;

        $translate.refresh();
        var init = window.location.toString();
        var index = init.indexOf('team-code?')+10;
        var urlParams = new URLSearchParams(init.substr(index));
        var userLang = navigator.language || navigator.userLanguage;

        $timeout(function (){

            angular.element('#email').focus();
            if(urlParams.get('email')){
                vm.registerAccount.email = urlParams.get('email');
            }
            if(urlParams.get('code')){
                vm.registerAccount.code = urlParams.get('code');
            }

            var lang = urlParams.get('lang');
            if(userLang.toLowerCase().indexOf('ja')>-1 || (lang && lang.toLowerCase()==='ja')){
                $translate.use('ja');
            }else{
                $translate.use('en');
            }

        });

        function register () {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;
                vm.errorExist = null;
                vm.errorMessage = null;

                vm.loading = true;

                ProfileService.claimTeamCode(vm.registerAccount.email,vm.registerAccount.code).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.loading = false;
                    console.log(response);
                    if (response.status === 400 && response.data.message === 'Runner not found') {
                        vm.errorExist = 'ERROR';
                        $translate('teamCode.runnerNotFound').then(function (title) {
                            vm.errorMessage = title;
                        });
                    }
                    /*else if (response.status === 400 && response.data.message === 'PromoCode already in use by runner') {
                        vm.errorExist = 'ERROR';
                        $translate('teamCode.promoCodeAlreadyInUse').then(function (title) {
                            vm.errorMessage = title;
                        });
                    }*/
                    else if (response.status === 400 && (response.data.message === 'PromoCode is not available')) {
                        vm.errorExist = 'ERROR';
                        $translate('teamCode.promoCodeIsNotAvailable').then(function (title) {
                            vm.errorMessage = title;
                        });
                    }
                    else if (response.status === 400 && (response.data.message === 'PromoCode already in use by runner')) {
                        vm.errorExist = 'ERROR';
                        $translate('teamCode.promoCodeAlreadyInUse').then(function (title) {
                            vm.errorMessage = title;
                        });
                    }

                });
        }
    }
})();
